document.addEventListener("DOMContentLoaded", function () {
  const hours = window.pickupHours || {};
  const messages = window.pickupMessages || {};
  const cutoff = window.pickupCutoff || 15;
  const timezoneOffset = window.pickupTimezoneOffset || 0;

  const selectElement = document.querySelector(".pickup-time-select");
  const messageElement = document.querySelector(".pickup-message");
  const errorElement = document.querySelector(".pickup-error");

  if (!selectElement) return;

  const now = new Date(new Date().getTime() + timezoneOffset * 60000);
  const day = now.toLocaleString("en-US", { weekday: "long" }).toLowerCase();

  const today = hours[day];
  if (!today || !today.enabled) {
    if (messageElement && messages.dayClosed) {
      messageElement.innerText = messages.dayClosed;
    }
    selectElement.style.display = "none";
    return;
  }

  const [openHour, openMin] = today.open.split(":").map(Number);
  const [closeHour, closeMin] = today.close.split(":").map(Number);

  const openTime = new Date(now);
  openTime.setHours(openHour, openMin, 0, 0);

  const closeTime = new Date(now);
  closeTime.setHours(closeHour, closeMin, 0, 0);

  const lastSlot = new Date(closeTime.getTime() - cutoff * 60000);

  if (now < openTime) {
    if (messageElement && messages.beforeOpen) {
      messageElement.innerText = messages.beforeOpen.replace("{time}", today.open);
    }
    selectElement.style.display = "none";
    return;
  }

  if (now > lastSlot) {
    if (messageElement && messages.afterClose) {
      messageElement.innerText = messages.afterClose;
    }
    selectElement.style.display = "none";
    return;
  }

  // Generate time slots
  const interval = 15;
  const options = [];
  const firstSlot = new Date(now.getTime() + interval * 60000);
  for (let time = new Date(firstSlot); time <= lastSlot; time.setMinutes(time.getMinutes() + interval)) {
    const label = `${messages.today || "Today"} ${time.toTimeString().slice(0, 5)}`;
    const option = document.createElement("option");
    option.value = label;
    option.text = label;
    options.push(option);
  }

  if (options.length > 0) {
    selectElement.innerHTML = "";

    const defaultOption = document.createElement("option");
    defaultOption.disabled = true;
    defaultOption.selected = true;
    defaultOption.value = "";
    defaultOption.text = messages.select_option || "Please select a pickup time";
    selectElement.appendChild(defaultOption);

    options.forEach(option => selectElement.appendChild(option));
    selectElement.style.display = "block";

    if (messageElement && messages.active) {
      messageElement.innerText = messages.active.replace("{time}", today.close);
    }

    if (messageElement && messages.sameDayNote) {
      const note = document.createElement("div");
      note.className = "pickup-same-day-note";
      note.innerText = messages.sameDayNote;
      messageElement.appendChild(note);
    }

    // NEW: Save selected pickup time in multiple languages
    selectElement.addEventListener("change", function () {
      const selectedTime = selectElement.value;

      const pickupNote = `
🇩🇪 Abholzeit: ${selectedTime}
🇬🇧 Pickup time: ${selectedTime}
🇻🇳 Thời gian lấy hàng: ${selectedTime}
`.trim();

      fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          attributes: {
            "📦 Pickup Time": pickupNote
          }
        })
      });
    });
  } else {
    if (messageElement && messages.afterClose) {
      messageElement.innerText = messages.afterClose;
    }
    selectElement.style.display = "none";
  }

  // Prevent checkout if no pickup time selected
  const cartForm = document.querySelector('form[action$="/cart"]');
  if (cartForm) {
    cartForm.addEventListener("submit", function (e) {
      if (!selectElement.value) {
        e.preventDefault();
        if (errorElement) {
          errorElement.textContent = "Please select a pickup time before proceeding.";
          errorElement.style.display = "block";
        } else {
          alert("Please select a pickup time before continuing.");
        }
      }
    });
  }
});
